// E-mail usado como login: sem '+' na parte local.
export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// E-mail usado só para notificação/contato: aceita '+' (ex.: nome+tag@x.com).
export const notificationEmailRegex =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmail = (email: string) => {
  return emailRegex.test(email);
};
export const validateNotificationEmail = (email: string) => {
  return notificationEmailRegex.test(email);
};
